<template>
  <div class="subsection-header d-flex align-items-center">
    <i class="feather icon-more-vertical mr-2 subsection-handle"></i>

    <input
      class="form-control form-control-sm mr-2 subsection-title-input"
      v-model.trim="sub.name"
      :placeholder="$t('risk.template.section_name')"
    />

    <span class="count-pill mr-2">({{ (sub.children && sub.children.length) || 0 }})</span>

    <b-button size="sm" class="mr-1" @click="$emit('toggle')">
      {{ sub.collapsed ? $t('actions.expand') : $t('actions.collapse') }}
    </b-button>

    <!-- Button multiselect in multiple-->
    <b-button
      v-if="multiSelect"
      size="sm"
      variant="outline-primary"
      class="mr-1"
      @click="$emit('move-selected-here')"
    >
      Mover seleccionados aquí
    </b-button>

    <b-button size="sm" variant="danger" class="mr-1" @click="$emit('remove')">
      {{ $t('actions.delete') }}
    </b-button>

    <b-button size="sm" variant="primary" title="Agregar pregunta" @click="$emit('add-field')">
      +
    </b-button>
  </div>
</template>

<script>
import { BButton } from "bootstrap-vue";
export default {
  components: { BButton },
  props: {
    sub: { type: Object, required: true },
    multiSelect: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
.subsection-header {
  background: #fbfbfb;
  border: 1px solid #e2e2e2;
  padding: .35rem .5rem;
  border-radius: 6px;
}
.subsection-title-input { font-weight: 600; font-size: 14px; }
.subsection-handle { cursor: move; }
.count-pill { font-size: 12px; color: #666; }
</style>
